import TextField from "./text/TextField.vue";
import TextareaField from "./text/TextareaField.vue";
import CheckboxField from "./selection/CheckboxField.vue";
import RadioField from "./selection/RadioField.vue";
import DatetimeField from "./date-time/DatetimeField.vue";
import DateField from "./date-time/DateField.vue";
import TimeField from "./date-time/TimeField.vue";
import FileImageField from "./file/FileImageField.vue";
import StarRatingField from "./rating/StarRatingField.vue";
import HeartRatingField from "./rating/HeartRatingField.vue";
import ThumbRatingField from "./rating/ThumbRatingField.vue";
import NumberRatingField from "./rating/NumberRatingField.vue";
import EmailField from "./text/EmailField.vue";
import PhoneNumberField from "./text/PhoneNumberField.vue";
import IdentityField from "./text/IdentityField.vue";

export default {
  "text-field": {
    component: TextField,
    defaultValue: "",
  },
  textarea: {
    component: TextareaField,
    defaultValue: "",
  },
  checkbox: {
    component: CheckboxField,
    defaultValue: [],
  },
  radio: {
    component: RadioField,
    defaultValue: "",
  },
  datetime: {
    component: DatetimeField,
    defaultValue: "",
  },
  date: {
    component: DateField,
    defaultValue: "",
  },
  time: {
    component: TimeField,
    defaultValue: "",
  },
  "image-file": {
    component: FileImageField,
    defaultValue: [],
  },
  "rating-angka": {
    component: NumberRatingField,
    defaultValue: 0,
  },
  "rating-jempol": {
    component: ThumbRatingField,
    defaultValue: 0,
  },
  "rating-bintang": {
    component: StarRatingField,
    defaultValue: 0,
  },
  "rating-hati": {
    component: HeartRatingField,
    defaultValue: 0,
  },
  email: {
    component: EmailField,
    defaultValue: "",
  },
  phone: {
    component: PhoneNumberField,
    defaultValue: ["62", ""],
  },
  "identity-field": {
    component: IdentityField,
    default: ["KTP", "", ""],
  },
  "seller-data": {
    component: undefined,
    default: "",
  },
};
